import { render, staticRenderFns } from "./AppFilesSelector.vue?vue&type=template&id=28edf79a&scoped=true&"
import script from "./AppFilesSelector.vue?vue&type=script&lang=js&"
export * from "./AppFilesSelector.vue?vue&type=script&lang=js&"
import style0 from "./AppFilesSelector.vue?vue&type=style&index=0&id=28edf79a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edf79a",
  null
  
)

export default component.exports